module.exports = __webpack_public_path__ + "img/prediction_export.f6f26de9.png";